/**
 * Leaderboard view. The server renders the HTML — we just fetch it and swap
 * it into place. No client-side schema, no JSON parsing. Classic hypermedia.
 */
export class LeaderboardView {
  private readonly body: HTMLElement;
  private pending = false;

  constructor() {
    this.body = document.getElementById("leaderboard-body") as HTMLElement;
  }

  async load(): Promise<void> {
    if (this.pending) return;
    this.pending = true;
    try {
      const res = await fetch("/api/leaderboard", {
        headers: { accept: "text/html" },
      });
      if (!res.ok) {
        this.body.innerHTML = `<p class="empty">Couldn't load leaderboard (${res.status}).</p>`;
        return;
      }
      const html = await res.text();
      this.body.innerHTML = html;
    } catch (err) {
      console.warn("leaderboard fetch failed", err);
      this.body.innerHTML = `<p class="empty">Couldn't reach the server.</p>`;
    } finally {
      this.pending = false;
    }
  }
}
